



import {Component, Prop, Vue} from 'vue-property-decorator';

const Island = () => import('@/components/Atoms/GrowTree/IsLand/Island.vue')

@Component({
  components: {Island}
})
export default class IslandGroup extends Vue {
  @Prop() data!: any
  @Prop(Number) type?: number
  @Prop({type: Boolean, default: false}) isFocus?: boolean

  private onClickIsland(data: any): void {
    this.$emit('click', data)
  }
}
